/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdAddressesAddresspersonid202,
  PutApiV1PersonIdAddressesAddresspersonid400,
  PutApiV1PersonIdAddressesAddresspersonid401,
  PutApiV1PersonIdAddressesAddresspersonid404,
  PutApiV1PersonIdAddressesAddresspersonid500,
  PutApiV1PersonIdAddressesAddresspersonidMutationRequest,
  PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
  PutApiV1PersonIdAddressesAddresspersonidPathParams,
} from "../../types/personRegisterController/PutApiV1PersonIdAddressesAddresspersonid.ts";
import { personAddressDetailViewModelSchema } from "../personAddressDetailViewModelSchema.ts";
import { updatePersonAddressRequestSchema } from "../updatePersonAddressRequestSchema.ts";

export const putApiV1PersonIdAddressesAddresspersonidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    addressPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonIdAddressesAddresspersonid202Schema = z.lazy(
  () => personAddressDetailViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdAddressesAddresspersonid400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdAddressesAddresspersonid401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdAddressesAddresspersonid404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdAddressesAddresspersonid500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonid500>;

export const putApiV1PersonIdAddressesAddresspersonidMutationRequestSchema =
  z.lazy(
    () => updatePersonAddressRequestSchema,
  ) as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonidMutationRequest>;

export const putApiV1PersonIdAddressesAddresspersonidMutationResponseSchema =
  z.lazy(
    () => putApiV1PersonIdAddressesAddresspersonid202Schema,
  ) as unknown as ToZod<PutApiV1PersonIdAddressesAddresspersonidMutationResponse>;
